import { FC, useMemo } from "react";
import { Picker } from "@design-system/Picker/Picker.lib";
import {
    GroupBy,
    GROUP_BY_LABELS,
    GROUP_BY_OPTIONS,
} from "./useGroupedTableData";

interface GroupBySelectProps {
    value: GroupBy;
    onValueChange: (val: GroupBy | null) => void;
    /** The groupings offered, in order; defaults to all of List's. */
    options?: readonly GroupBy[];
}

export const GroupBySelect: FC<GroupBySelectProps> = ({
    value,
    onValueChange,
    options = GROUP_BY_OPTIONS,
}) => {
    const items = useMemo(
        () =>
            options.map((option) => ({
                value: option,
                label: GROUP_BY_LABELS[option],
            })),
        [options],
    );
    return (
        <Picker.Select
            items={items}
            value={value}
            onValueChange={onValueChange}
        />
    );
};
